import React from "react";
import styles from "./style.module.css";
import Popover from '@material-ui/core/Popover';
import * as PropTypes from "prop-types";

const PaymentMenu = React.memo(({ id, open, anchorEl, handleClose, handleDelete }) => {
  return (
    <Popover
      id={id}
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
    >
      <div className={styles.menuBlock}>
        <div
          className={styles.menuItem}
          onClick={() => handleDelete(id)}
        >
          Remove payment method
        </div>
      </div>
    </Popover>
  );
});

PaymentMenu.propTypes = {
  id: PropTypes.string,
  open: PropTypes.bool,
  anchorEl: PropTypes.object,
  handleClose: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired
};

PaymentMenu.defaultProps = {
  id: null,
  open: false,
  anchorEl: undefined,
  handleDelete: () => undefined,
  handleClose: () => undefined,
};



export default PaymentMenu;
